import React from 'react';
import { Table } from '@zillow/constellation';
import { VoidDisplay } from 'components/order/fees/edit/disbursements/Voiding/VoidDisplay';
import { VoidWireButton } from 'components/order/fees/edit/disbursements/Voiding/VoidWireButton';
import {
  IEscrowWireDisbursementsData,
  prettyWireDisbursementsCategories,
} from 'types/order/escrow/IEscrowWireDisbursementsData';
import { getEscrowBankAccountLabel } from 'ui-toolkit/utilities/getEscrowBankAccountLabel';
import { currencyDisplay } from 'utilities/shared/currencyDisplay';
import { FeeInformation } from '../FeeInformationColumn';
import { DateFormat, getDateString } from '../../../../../ui-toolkit/utilities/getDateString';
import { useHasFeatureFlag } from 'selectors/useHasFeatureFlag';

export const NO_FED_REF_WAS_PROVIDED_MSG = 'No Fed Ref # was Supplied by Bank';

export const getFederalReferenceNumber = (completedAt?: string, federalReferenceNumber?: string) => {
  if (!completedAt) {
    return null;
  }
  return federalReferenceNumber || NO_FED_REF_WAS_PROVIDED_MSG;
};

export const WireDisbursementRow: React.FC<{ item: IEscrowWireDisbursementsData }> = ({ item }) => {
  const isSpruceWithZillowEnabled = useHasFeatureFlag('pinecone.spruce-with-zillow-closing');
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const baseName = isSpruceWithZillowEnabled ? item.escrowBankAccount.legalName : item.escrowBankAccount.spruceName;
  const selectedNickname = isZillowClosingEnabled
    ? item.escrowBankAccount.nickname
    : item.escrowBankAccount.spruceNickname;
  const displayName = selectedNickname ? `${baseName} ${selectedNickname}` : baseName;
  return (
    <Table.Row key={item.id}>
      <Table.Cell>
        <FeeInformation id={item.id} />
      </Table.Cell>
      <Table.Cell>{item.beneficiary}</Table.Cell>
      <Table.Cell>{currencyDisplay(item.amountCents, true)}</Table.Cell>
      <Table.Cell>{getEscrowBankAccountLabel(item.escrowBankAccount, isSpruceWithZillowEnabled, isZillowClosingEnabled)}</Table.Cell>
      <Table.Cell>{item.escrowBankAccount.accountNumber}</Table.Cell>
      <Table.Cell>{displayName}</Table.Cell>
      <Table.Cell>{item.accountNumber}</Table.Cell>
      <Table.Cell>{item.routingNumber}</Table.Cell>
      <Table.Cell>{item.memo}</Table.Cell>
      <Table.Cell>{prettyWireDisbursementsCategories[item.category]}</Table.Cell>
      <Table.Cell>{item.wellsFargoTransactionNumber}</Table.Cell>
      <Table.Cell>{getFederalReferenceNumber(item.completedAt, item.federalReferenceNumber)}</Table.Cell>
      <Table.Cell>
        {item.enqueuedForDisbursementAt && getDateString(DateFormat.hugeDateTime, item.enqueuedForDisbursementAt, true)}
      </Table.Cell>
      <Table.Cell>{item.sendAt && getDateString(DateFormat.hugeDateTime, item.sendAt, true)}</Table.Cell>
      <Table.Cell>{item.completedAt && getDateString(DateFormat.hugeDateTime, item.completedAt, true)}</Table.Cell>
      <Table.Cell>
        <VoidDisplay item={item} prettyVoidReason={item.voidReason} />
        <VoidWireButton wireDisbursement={item} />
      </Table.Cell>
    </Table.Row>
  );
};
